import { useEffect } from "react";

const SITE_NAME = "SRI Services";
const DEFAULT_TITLE = "SRI Services, Inc.";

/**
 * Sets document.title for the current route. React otherwise leaves the
 * title at whatever index.html shipped with, which fails WCAG 2.4.2 Page
 * Titled because every route announces the same title to screen readers
 * and shows the same browser-tab label.
 *
 * Pass the page-specific portion only — this hook appends " | SRI Services".
 */
export function useDocumentTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
  }, [title]);
}
